import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../redux/actions/index';
import TravcoHeader from 'travco-header';
import { TravcoFooter } from 'travco-footer';
import Search from './search-container';
import { Route } from 'react-router-dom';
import CallbackPage from './callback-page';
import { userManager } from '../utils/user-manager';

class App extends Component {
    constructor(props) {
        super(props);
        this.signOut = this.signOut.bind(this);

        if (window.location.pathname !== '/callback' && (!props.oidc || !props.oidc.user || props.oidc.user.expired)) {
            if (userManager.settings.authority) {
                userManager.signinRedirect({
                    state: { returnTo: window.location.pathname + window.location.search }
                });
            }
        }
    }

    signOut() {
        userManager.signoutRedirect();
    }

    render() {
        let user = null;

        if (typeof this.props.oidc !== 'undefined' && this.props.oidc.user !== null) {
            user = this.props.oidc.user.profile;
        }

        return (
            <div className="app-wrapper">
                <div className="app-header">
                    <TravcoHeader
                        signOut={this.signOut}
                        service="search"
                        user={user}
                        domain={this.props.settings.serviceDomain}
                        settings={this.props.settings}
                        data={[]}
                        viewName="Hotel Availability"
                    />
                </div>
                <div className="app-body">
                    <Route exact path="/" component={Search} />
                    <Route path="/callback" component={CallbackPage} />
                </div>
                <div className="app-footer">
                    <TravcoFooter />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        oidc: state.oidc,
        settings: state.settings
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
